import styled from 'styled-components';
import { FlexBetween, FlexCenterAligned } from '../../../styled/common';
import { BookmarkContainer } from '../../Bookmark/styled';

export const AppBar = styled(FlexBetween)<{ $scrollProgress: string }>`
  --scroll-progress: ${({ $scrollProgress }) => $scrollProgress};
  align-items: flex-end;
  background-color: rgba(255, 255, 255, var(--scroll-progress));
  position: fixed;
  top: 0;
  z-index: 95;
  width: 100%;
  height: ${({ theme }) =>
    theme.isWebView
      ? `${60 + Math.max(theme.webview?.insets?.top ?? 0, 15)}px`
      : `calc(60px + max(env(safe-area-inset-top), 15px))`};
  padding: 0 15px 12.5px;
`;

export const Button = styled(FlexCenterAligned)`
  width: 35px;
  height: 35px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 17.5px;
  position: relative;

  ${BookmarkContainer} {
    right: 7px;
  }

  circle {
    fill: transparent;
  }
`;

export const StyledBackButton = styled(Button)`
  > div {
    position: relative;
    height: 16px;
    width: 10px;
  }

  svg {
    transform: none;
  }
`;

export const Actions = styled(FlexCenterAligned)`
  gap: 15px;
`;
